<div class="container">
     <fap-company-layout 
          [company]="company$ | async"
          (updateCompany)="updateCompany($event)">
     </fap-company-layout>
</div>
